import { render, staticRenderFns } from "./ComboboxIndicador.vue?vue&type=template&id=3ef8c918"
import script from "./ComboboxIndicador.vue?vue&type=script&lang=js"
export * from "./ComboboxIndicador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports